<!-- MODULO SOLO TESTO 2 COLONNE -->
<div class="container mb-5 modulo testo">
  <div class="row">
    <div class="col-6 mb-3 mb-md-0" [innerHTML]="campi.TESTO1?.valore | safe">
    </div>
    <div class="col-6" [innerHTML]="campi.TESTO2?.valore | safe">
    </div>
  </div>
</div>
<!-- //MODULO SOLO TESTO 2 COLONNE -->